import { DatabaseServerOrPathFragment, DatabasesExternalAssetsDisplayGridRowData } from '@tableau/data-catalog-client-components';
import { Action } from 'redux';

import { IExplorableItemTypeInfo } from '../../../ts/models/resourceInfoParts';
import { GroupDatabases } from '../AppActionTypes';

export type DatabaseForGrouping =
  IExplorableItemTypeInfo<'database'> &
  Pick<DatabasesExternalAssetsDisplayGridRowData, 'id' | 'luid' | 'connectionType' | 'isGrouped' | 'isEmbedded'> &
  DatabaseServerOrPathFragment;

export interface GroupDatabasesAction extends Action {
  readonly items: ReadonlyArray<DatabaseForGrouping>;
}

export function groupDatabasesAction(items: ReadonlyArray<DatabaseForGrouping>): GroupDatabasesAction {
  if (items.length < 2) {
    throw new Error('Group Databases action must be called with at least 2 items');
  }

  return {
    type: GroupDatabases,
    items
  };
}
